const freightProvision = {
  statusType: {
    DISPATCH_DELIVERED: 1,
    DELIVERD_INVOICE: 2,
    INVOICE_APPROVED: 3,
  },
};

module.exports = { freightProvision };
